<ep-sub-panel blockWidth="full" [form]="form" title="" panelType="transparent">
  <div style="border-bottom-style: solid; border-bottom-width: 2px; border-bottom-color: black; margin-bottom: 2px">
    <ep-field format="container" columnSpan="200px"> <b style="font-size: 14px">Quick Correspond Options</b></ep-field>
  </div>
  <form [formGroup]="form">
    <ep-field-section>
      <ep-field
        label="Template"
        columnSpan="2"
        format="dropdownSelector"
        controlPath="CorrespondOptions.Cover_Memo_Object_Code"
        [options]="{ codeValues: correspondTemplates$ | async, nullValue: { Code: '', Code_Desc: 'no template' } }"
      ></ep-field>
      <ep-field
        label="Deliver Via"
        columnSpan="90px"
        format="dropdownSelector"
        controlPath="CorrespondOptions.Delivery_Method"
        [options]="{
          codeValues: [
            { Code: 'D', Code_Desc: 'Default' },
            { Code: 'E', Code_Desc: 'Email' },
            { Code: 'M', Code_Desc: 'Mail (Print)' }
          ]
        }"
      ></ep-field>
      <ep-field label="Subject" columnSpan="6" format="text-80" controlPath="CorrespondOptions.Subject"> </ep-field>
      <ep-field
        label="Message"
        columnSpan="6"
        controlPath="CorrespondOptions.Message"
        format="textbox-32767"
        [options]="{ rows: 3 }"
      >
      </ep-field>
    </ep-field-section>
  </form>
</ep-sub-panel>
